import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-empty-box',
	templateUrl: './icon-empty-box.component.svg',
})
export class IconEmptyBoxComponent {}
